import { render, staticRenderFns } from "./archive-event-modal.vue?vue&type=template&id=0cd9fe2b&"
import script from "./archive-event-modal.vue?vue&type=script&lang=js&"
export * from "./archive-event-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports